import { render } from "./TicketDetail.vue?vue&type=template&id=6742d71c&ts=true"
import script from "./TicketDetail.vue?vue&type=script&lang=ts"
export * from "./TicketDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__